import { SellingPlansState } from './types'

export const sellingPlansState: SellingPlansState = {
  sellingPlanGroups: [],
  selectedSellingPlanGroupId: '',
  selectedSellingPlanId: ''
}
